/**
 * Browser-only payment-pending reconcile trigger (ADR-0019).
 */
import { apiFetch } from '@/lib/api-client';

export async function reconcileRolesWhilePaymentPending(): Promise<void> {
  await apiFetch('/subscriptions/reconcile-roles', { method: 'POST' });
}
